import React from "react";

interface Props {
  goodLeft?: boolean;
  values: number[];
  texts?: string[];
  width?: string;
  height?: string;
  showZero?: boolean;
}

const PercentBar: React.FC<Props> = ({
  goodLeft = true,
  values,
  texts = undefined,
  height = "24px",
  width = "100%",
  showZero = false,
}) => {

  const colors = ["aquamarine-600", "orange-300", "orange-500", "cherry-600"];

  const nrValues = values.length;
  let colorClasses: Array<string> = [];
  if (nrValues === 3) {
    if (goodLeft) {
      colorClasses = [colors[0], colors[2], colors[3]];
    } else {
      colorClasses = [colors[3], colors[2], colors[0]];
    }
  } else if (nrValues === 4) {
    if (goodLeft) {
      colorClasses = colors;
    } else {
      colorClasses = [colors[3], colors[2], colors[1], colors[0]];
    }
  }

  const showValues: number[] = [];
  const showTexts: string[] = [];
  const bgColors: string[] = [];

  for (let i = 0; i < nrValues; i++) {
    const value = values[i];
    if (value > 0 || showZero) {
      bgColors.push(colorClasses[i]);
      showValues.push(value);
      if (texts) {
        showTexts.push(texts[i]);
      }

    }
  }

  const showValuesNr = showValues.length;

  let totalValue = 0;
  for (const value of values) {
    totalValue += value;
  }

  return (
    <div style={{height: height, width: width}} className="rounded-sm flex">
      {
        showValues.map((value, i) => {
          let percent = 100 * value / totalValue;
          let txt = value.toFixed(0) + "";
          if (texts) {
            txt += showTexts[i];
          }
          if (percent < 5) {
            percent = 5;
          }
          let cls = "flex justify-center z-title4 items-center text-indigo-900! bg-" + bgColors[i];
          let style = {width: percent + "%", borderRadius: "none"};
          if (i === 0) {
            if (i === showValuesNr - 1) {
              style['borderRadius'] = height;
            } else {
              style['borderRadius'] = height + " 0 0 " + height;
            }
          } else if (i === showValuesNr - 1) {
            style['borderRadius'] = "0 " + height + " " + height + " 0";
          }
          return (
            <div key={i} className={cls} style={style}>{txt}</div>
          )
        })
      }
    </div>
  );
};

export default PercentBar;
